/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerateStreamContainer_settings = {
    readonly auth: {
        readonly integrations: {
            readonly sso: {
                readonly enabled: boolean;
                readonly targetFilter: {
                    readonly admin: boolean;
                };
            };
        };
    };
    readonly " $refType": "ModerateStreamContainer_settings";
};
export type ModerateStreamContainer_settings$data = ModerateStreamContainer_settings;
export type ModerateStreamContainer_settings$key = {
    readonly " $data"?: ModerateStreamContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateStreamContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateStreamContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Auth",
            "kind": "LinkedField",
            "name": "auth",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthIntegrations",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SSOAuthIntegration",
                            "kind": "LinkedField",
                            "name": "sso",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "enabled",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthenticationTargetFilter",
                                    "kind": "LinkedField",
                                    "name": "targetFilter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "admin",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '21b402087c00d87d040ce655f3ab2869';
export default node;
